const settingsReducer = (state, action) => {
  const {
    type,
    payload
  } = action;
  if (type === "settings/set") {
    if (state[payload.key] === payload.value) {
      return state;
    }
    return {
      ...state,
      [payload.key]: parseFloat(payload.value),
    }
  }
  return state;
}

export default settingsReducer;
